import React from 'react';
import { testimonials } from '../mock';
import { Quote } from 'lucide-react';

const Testimonials = () => (
  <section className="px-4 md:px-10 py-20">
    <div className="mx-auto max-w-[1240px]">
      <div className="text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 rounded-full border border-emerald-700/30 bg-emerald-100 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-800">
          Voices
        </div>
        <h2 className="mt-4 font-serif text-emerald-950 text-4xl md:text-5xl leading-[1.05] tracking-tight">
          Trusted by builders of <span className="italic text-emerald-600">tomorrow</span>.
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
        {testimonials.map((t) => (
          <figure key={t.id} className="rounded-2xl border border-emerald-900/60 bg-gradient-to-b from-[#0a1e14] to-[#061810] p-7">
            <Quote size={22} className="text-emerald-400" />
            <blockquote className="mt-4 text-emerald-50/90 text-[15px] leading-relaxed font-serif">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-700 flex items-center justify-center text-emerald-950 font-semibold">
                {t.name.charAt(0)}
              </div>
              <div>
                <div className="text-white text-sm font-medium">{t.name}</div>
                <div className="text-emerald-200/60 text-xs">{t.role}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
